module.exports = __webpack_public_path__ + "static/img/icon3.9be07bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/App/icon3.png
// module id = b3sa
// module chunks = 1